/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import React, {Component} from 'react';

import SelectField from './SelectField';


class ReportsSelect extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        setSelected: PropTypes.func.isRequired,
        endPoint: PropTypes.object.isRequired,
        queryParams: PropTypes.object,
        callbackResultsMapFunc: PropTypes.func.isRequired,
        selected: PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.number,
        }),
    };

    static defaultProps = {
        queryParams: {},
        selected: {
            label: '',
            value: 0,
        },
    };

    handleChange = (_, selectedValue) => {
        this.props.setSelected(selectedValue);
    };

    render() {
        return (
            <SelectField
                name={this.props.name}
                label={this.props.label}
                value={this.props.selected}
                onChange={this.handleChange}
                loadOptions={(input, callback) => {
                    this.props.endPoint.fetch(null, {search: input, ...this.props.queryParams}).then(
                        (data) => {
                            callback(null, {
                                options: data.results.map(this.props.callbackResultsMapFunc),
                                complete: true,
                            });
                        },
                        console.error,
                    );
                }}
            />
        );
    }
}


export default ReportsSelect;



// WEBPACK FOOTER //
// ./src/components/ReportsSelect.js